module.exports = __webpack_public_path__ + "static/media/culogo.287a1820.png";